import { BaseDialog } from '@/components/dialog/base-dialog'
import { Column, Row } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage } from '@/utils/layer'
import React from 'react'
import MallSortGoodsGroup from './component/mall-sort-group'
import { mallSortGoodStore } from './store'
import './sort-good.scss'
import MallSortGoodsList from './component/mall-sort-goods-list'
import { useUnmount } from 'ahooks'
import { goodsShelfStore } from '../../store/goods-shelf'

const MallGoodsSort = () => {
    const cls = useBemClass('mall-goods-sort')

    useUnmount(() => {
        if (mallSortGoodStore.goodUpdate) {
            goodsShelfStore.setUpdateGroupStatus()
            mallSortGoodStore.setGoodUpdate(false)
        }
        if (mallSortGoodStore.groupUpdate) {
            goodsShelfStore.setUpdateGroup()
            mallSortGoodStore.setGroupUpdate(false)
        }
    })

    return (
        <BaseDialog
            isShow
            title="商品排序"
            onClose={() => {
                layerManage.pop()
                mallSortGoodStore.setActiveId(void 0)
                mallSortGoodStore.setSecondId(0)
            }}
        >
            <div className={cls('des')}>
                *拖拽卡片调整分组/商品排序的，越靠上的排序优先级越高；“近期热卖”、“最新上架”分组商品不可调整排序；独立商城货架修改后，商品库不会同步修改
            </div>
            <Row data-aling-items-center className={cls('container')}>
                <Column>
                    <div className={cls('group-title')}>分组名</div>
                    <div className={cls('group')}>
                        <MallSortGoodsGroup />
                    </div>
                </Column>
                <MallSortGoodsList />
            </Row>
        </BaseDialog>
    )
}

export default MallGoodsSort
